<template>
    <div id="wrapper">
        <Director-Bar index="4"></Director-Bar>

        <div id="content-wrapper">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-4">

                        <form @submit.prevent="addItem" class="form-inline mb-3">
                            <div class="form-group mr-3">
                                <input type="text" class="form-control" placeholder="Group name"
                                    v-model="added_item_name" />
                            </div>
                            <button class="btn btn-info" type="submit">
                                <i class="fas fa-plus"></i> Add
                            </button>
                        </form>
                        <b-table id="my-table" bordered head-variant="dark" hover responsive :fields="fields" :items="items"
                            selectable select-mode="single" @row-selected="onRowSelected" table-variant="light">
                            <template v-slot:cell(selected)="{ rowSelected }">
                                <template v-if="rowSelected">
                                    <span aria-hidden="true">&check;</span>
                                    <span class="sr-only">Selected</span>
                                </template>
                                <template v-else>
                                    <span aria-hidden="true">&nbsp;</span>
                                    <span class="sr-only">Not selected</span>
                                </template>
                            </template>
                            <!-- <template v-slot:cell(name)="data" v-if="hethong_update">
                  <input
                    type="text"
                    class="form-control"
                    :value="data.item.name"
                    required
                    @change="updateItem(data, $event)"
                  />
                </template>
                <template v-slot:cell(deleted)="data" v-if="hethong_delete">
                  <button class="btn btn-danger" @click="deleteItem(data)">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </template>-->
                            <template v-slot:cell(name)="data">
                                <input type="text" class="form-control" :value="data.item.name" required
                                    @change="updateItem(data, $event)" />
                            </template>
                            <template v-slot:cell(deleted)="data">
                                <b-link class="text-danger" href="#" @click.prevent="deleteItem(data)">
                                    <i class="fas fa-trash"></i>
                                </b-link>
                                <!-- <button class="btn btn-danger" @click="deleteItem(data)">
                    <i class="fas fa-trash-alt"></i>
                  </button> -->
                            </template>
                        </b-table>
                    </div>
                    <div class="col-8">
                        <!-- <form @submit.prevent="addUser" class="form-inline mb-3" v-show="item_selected != null && hethong_insert"> -->
                        <form @submit.prevent="addUser" class="form-inline mb-3" v-show="item_selected != null">
                            <div class="form-group mr-3">
                                <div style="width: 500px;">
                                    <!-- <vue-autosuggest
                      v-model="userQuery"
                      :suggestions="employeesuggestions"
                      :input-props="{id:'autosuggest__input', placeholder:'Name ?'}"
                      @selected="onSelected"
                      @input="onInputChange"
                      :get-suggestion-value="getSuggestionValue"
                    >
                      <template slot-scope="{suggestion}" style="display: flex; align-items: center;">
                        <span class="my-suggestion-item mr-3">{{suggestion.item.hovaten}}</span>
                      </template>
                    </vue-autosuggest> -->
                                    <multiselect v-model="position" placeholder="Select one" label="name" track-by="name"
                                        deselectLabel="Enter to remove" :searchable="true" :options="position_items"
                                        @select="unlockHopitalCity" @remove="lockHopitalCity">
                                    </multiselect>

                                </div>
                            </div>
                            <button class="btn btn-info" type="submit">
                                <i class="fas fa-plus"></i> Add
                            </button>
                        </form>
                        <b-table id="my-table" bordered head-variant="dark" hover responsive :fields="fieldsUser"
                            :items="employees" table-variant="light">
                            <!-- <template v-slot:cell(deleted)="data" v-if="hethong_delete"> -->
                            <template v-slot:cell(deleted)="data">
                                <b-link class="text-danger" href="#" @click.prevent="deleteUser(data)">
                                    <i class="fas fa-trash"></i>
                                </b-link>
                                <!-- <button class="btn btn-danger" @click="deleteUser(data)">
                    <i class="fas fa-trash-alt"></i>
                  </button> -->
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </div>
    </div>
</template>
  
<script>
import axios from "axios";

import DirectorBar from "../Bonus/Bonus_Bar.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
export default {
    name: "Roles",
    components: {

        DirectorBar,
        Multiselect
    },
    computed: {


    },
    data() {
        return {

            added_item_name: "",
            items: [],
            item_selected: null,

            //list employees of selected group
            employees: [],

            //user suggestion
            userQuery: "",
            employeeselected: null,
            employeesuggestions: [
                {
                    data: [],
                },
            ],
            //table
            position_items: [],
            position: null,
            fields: [
                {
                    key: "selected",
                    label: "",
                    thStyle: { width: "50px !important" },
                },
                {
                    key: "name",
                    label: "Name",
                },
                {
                    key: "deleted",
                    label: "",
                    thStyle: { width: "50px !important" },
                },
            ],
            fieldsUser: [
                {
                    key: "name",
                    label: "Name",
                },
                {
                    key: "role",
                    label: "Position",
                },
                {
                    key: "company",
                    label: "Company",
                },
                {
                    key: "deleted",
                    label: "",
                    thStyle: { width: "5px !important" },
                },
            ],
        };
    },
    beforeRouteEnter(to, from, next) {

        axios
            .all([
                axios.get("/api/bonus/getGroup"),
                axios.get("/api/bonus/getAllPositions"),

            ])
            .then(
                axios.spread((group, positions) => {
                    next((vm) =>
                        vm.initData(group.data, positions.data)
                    );
                })
            );

    },
    methods: {
        initData(group, positions) {
            this.items = group;
            this.position_items = positions;
        },
        getEmployeeByRole() {
            if (this.item_selected == null) {
                this.employees = [];
                return;
            }
            axios
                .get(`/api/bonus/getPositionsInGroup?groupID=${this.item_selected[0].id}`)
                .then((res) => {
                    this.employees = res.data;
                })
                .catch((err) => {
                    this.employees = [];
                    this.$toast.error(err.response.data, "Error", { timeout: 3000 });
                });
        },
        onRowSelected(item) {
            if (item.length == 0) {
                this.item_selected = null;
                this.employees = [];
            } else {
                this.item_selected = item;
                this.getEmployeeByRole();
            }
        },
        //   onInputChange(text) {
        //     this.employeeselected = null;
        //     if (text == "") {
        //       this.employeesuggestions = [
        //         {
        //           data: [],
        //         },
        //       ];
        //     } else {
        //       axios
        //         .get(`/api/employeesystem?q=${text}`)
        //         .then((res) => {
        //           this.employeesuggestions = [
        //             {
        //               data: res.data.items,
        //             },
        //           ];
        //         })
        //         .catch((err) => {});
        //     }
        //   },
        onSelected(item) {
            this.employeeselected = item.item;
        },
        resetAutoSuggest() {
            this.position = null;
            // this.employeeselected = null;
            // this.employeesuggestions = [
            //     {
            //         data: [],
            //     },
            // ];
            // this.userQuery = "";
        },
        getSuggestionValue(suggestion) {
            return suggestion.item.hovaten;
        },
        unlockHopitalCity(city) {
            this.item.role = null;
        },
        lockHopitalCity() {
            this.item.role = null;
        },
        addItem() {

            if (!(this.added_item_name && this.added_item_name.length)) {
                this.$toast.error("Please enter a name !", "Error", { timeout: 2000 });
            } else {

                var isItemExist = this.items.filter(
                    (role) => role.name == this.added_item_name
                );
                if (isItemExist.length > 0)
                    this.$toast.error("The name already exists !", "Error", { timeout: 2000 });
                else {

                    axios
                        .post("/api/bonus/storeGroupTemplate", {
                            id: 0,
                            name: this.added_item_name,
                            updateBy: this.$store.state.auth.accountId,
                        })
                        .then((res) => {
                            this.items.push(res.data);
                            this.added_item_name = "";
                            this.$toast.success("Add data successfully", "Successful", {
                                timeout: 2000,
                            });
                        })
                        .catch((err) => {
                            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
                            this.added_item_name = "";
                        });
                }
            }
        },
        deleteItem(data) {
            this.$toast.question("Do you really want to delete the data?", "Warning", {
                timeout: 20000,
                close: false,
                overlay: true,
                displayMode: "once",
                position: "center",
                buttons: [
                    [
                        "<button><b>Có</b></button>",
                        (instance, toast) => {
                            axios
                                .delete(`api/bonus/deleteGroupTemplate?id=${data.item.id}&updateBy=${this.$store.state.auth.accountId}`)
                                .then((res) => {
                                    this.items.splice(data.index, 1);
                                    this.$toast.success("Delete successfully", "Successful", {
                                        timeout: 3000,
                                    });
                                })
                                .catch((err) => {
                                    this.$toast.error(err.response.data, "Error", {
                                        timeout: 3000,
                                    });
                                });
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                        true,
                    ],
                    [
                        "<button>Không</button>",
                        function (instance, toast) {
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                    ],
                ],
            });
        },
        updateItem(data, event) {
            var new_item_name = event.target.value;
            if (!(new_item_name && new_item_name.length)) {
                this.$toast.error("Please enter your name", "Error", { timeout: 3000 });
                event.target.value = data.item.name;
            } else {
                var isItemExist = this.items.filter(
                    (item) =>
                        item.name.toLowerCase() === new_item_name.toLowerCase() &&
                        item.id != data.item.id
                );
                if (isItemExist.length > 0) {
                    this.$toast.error("Name already exists", "Error", { timeout: 2000 });
                    event.target.value = data.item.name;
                } else {
                    axios
                        .post("/api/bonus/storeGroupTemplate", {
                            id: data.item.id,
                            name: new_item_name,
                            updateBy: this.$store.state.auth.accountId,
                        })
                        .then((res) => {
                            this.$toast.success("Update successful", "Successful", {
                                timeout: 3000,
                            });
                            this.items[data.index].name = new_item_name;
                        })
                        .catch((err) => {
                            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
                            event.target.value = data.item.name;
                        });
                }
            }
        },
        addUser() {
            if (this.position == null) {
                this.$toast.error("Please select a staff member", "Error", {
                    timeout: 2000,
                });
            } else {
                // var isItemExist = this.employees.filter(
                //     (item) => item.id == this.position.id);
                // if (isItemExist.length > 0) {
                //     this.$toast.error("Position already exists", "Error", {
                //         timeout: 3000,
                //     });
                // this.resetAutoSuggest(); 
                // }else{
                axios
                    .post(`/api/bonus/storePositionInGroup`, {
                        id: 0,
                        groupID: this.item_selected[0].id,
                        positionID: this.position.id,
                    })
                    .then((res) => {
                        this.employees.push(res.data);
                        this.resetAutoSuggest();
                        this.$toast.success("Add Successful", "Successful", {
                            timeout: 3000,
                        });
                    })
                    .catch((err) => {
                        alert(err);
                    });
                // }
            }
        
        },
        deleteUser(data) {
            this.$toast.question("Do you really want to delete?", "Warning", {
                timeout: 20000,
                close: false,
                overlay: true,
                displayMode: "once",
                position: "center",
                buttons: [
                    [
                        "<button><b>Yes</b></button>",
                        (instance, toast) => {
                            axios
                                .delete(
                                    `/api/bonus/deletePositionsInGroup?groupID=${this.item_selected[0].id}&positionID=${data.item.id}`
                                )
                                .then((res) => {
                                    this.employees.splice(data.index, 1);
                                    this.$toast.success("Delete Successful !", "Successful", {
                                        timeout: 3000,
                                    });
                                })
                                .catch((err) => {
                                    this.$toast.error(err.response.data, "Error", {
                                        timeout: 3000,
                                    });
                                });
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                        true,
                    ],
                    [
                        "<button>Không</button>",
                        function (instance, toast) {
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                    ],
                ],
            });
        },
    },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
  